export default {
  /** 显示错误信息 */
  showMsg: function (vm, errorInfo) {
    let htmlTempStart = '<div class="baize-alert-container">' +
        '<div class="baize-alert-header">' +
          '<div class="baize-alert-title">校验异常</div>' +
          '<button class="baize-alert-header-btn baize-alert-btn-close"><i class="fa fa-close"></i></button>' +
        '</div>' +
        '<div class="baize-alert-content" style="width: ' + (window.innerWidth - 200) + 'px; height: ' + (window.innerHeight - 200) + 'px">' +
          '<div class="baize-alert-msg">' +
            '<p class="msg-topic">对不起，系统出现校验异常。<br/>请检查提交的数据。</p>' +
            '<div class="baize-alert-msg-ctn">'
    let htmlTempData = ''
    for (let i = 0; i < errorInfo.length; i++) {
      htmlTempData = htmlTempData + '<span style="font-size:12px;">{' + errorInfo[i].tag + '} <br>'
      for (let j = 0; j < errorInfo[i].errors.length; j++) {
        htmlTempData = htmlTempData + '[' + errorInfo[i].errors[j].fieldName + ']: '
        for (let k = 0; k < errorInfo[i].errors[j].message.length; k++) {
          htmlTempData = htmlTempData + errorInfo[i].errors[j].message[k] + '&nbsp;&nbsp;&nbsp;&nbsp;'
        }
        htmlTempData = htmlTempData + '<br>'
      }

      htmlTempData = htmlTempData + '</span><br/>'
    }

    let htmlTempEnd =
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="baize-alert-btns">' +
          '<button class="baize-alert-button baize-alert-btn-submit baize-alert-color-danger"><span>关闭</span></button>' +
          '<button class="baize-alert-button baize-alert-btn-copy"><span>复制到剪切板</span></button>' +
        '</div>' +
      '</div>'
    let $baizeModal = document.createElement('div')
    $baizeModal.setAttribute('class', 'baize-modal')
    let $msgModal = document.createElement('div')
    $msgModal.setAttribute('class', 'baize-alert-modal')
    $msgModal.innerHTML = htmlTempStart + htmlTempData + htmlTempEnd
    /*
     * 复制按钮
     */
    $msgModal.getElementsByClassName('baize-alert-btn-copy')[0].onclick = function () {
      let $msgP = $msgModal.getElementsByClassName('baize-alert-msg-ctn')[0]
      if (document.body.createTextRange) {
        let range = document.body.createTextRange()
        range.moveToElementText($msgP)
        range.select()
      } else if (window.getSelection) {
        let selection = window.getSelection()
        let range = document.createRange()
        range.selectNodeContents($msgP)
        selection.removeAllRanges()
        selection.addRange(range)
      } else {
        // 提示复制失败
        vm.$notify({position: 'bottom-right', type: 'error', message: '复制失败'})
      }
      document.execCommand('Copy')
    }
    /*
     * 关闭按钮
     */
    $msgModal.getElementsByClassName('baize-alert-btn-submit')[0].onclick = function () {
      document.body.removeChild($msgModal)
      document.body.removeChild($baizeModal)
    }
    /*
     * 窗口关闭按钮
     */
    $msgModal.getElementsByClassName('baize-alert-btn-close')[0].onclick = function () {
      document.body.removeChild($msgModal)
      document.body.removeChild($baizeModal)
    }
    document.body.appendChild($msgModal)
    document.body.appendChild($baizeModal)
  }
}



// WEBPACK FOOTER //
// ./src/baize/src/ValidateHandlerWindow.js